"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndexedDBHandler = void 0;
var type_1 = require("./type");
var IndexedDBHandler = /** @class */ (function () {
    /**
      * @param {string} DBName name of dataBase
      * @param {number} DBVersion version of dataBase
      * @param {Function} DBSchema schema of dataBase
      */
    function IndexedDBHandler(DBName, DBVersion, DBSchema) {
        this.DBName = DBName;
        this.DBVersion = DBVersion;
        this.DBSchema = DBSchema;
        this.db = null;
    }
    /**
     * @async
     * Open a connection to database and create schema if is first connection
     * @returns {Promise<void>}
     */
    IndexedDBHandler.prototype.openDB = function () {
        var _this = this;
        var _indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB;
        return new Promise(function (res, rej) {
            var request = _indexedDB.open(_this.DBName, _this.DBVersion);
            request.onerror = function (event) {
                rej("Database error : ".concat(event.target.errorCode));
            };
            request.onsuccess = function (event) {
                _this.db = event.target.result;
                res();
            };
            request.onupgradeneeded = _this.DBSchema;
        });
    };
    /**
     * @async
     * Helper for run action on DB
     * @param {string} storeName Name of the store
     * @param {Object | string} data data
     * @param {IndexedDBHandlerAction} methode
     * @returns {Promise<any>}
     */
    IndexedDBHandler.prototype.makeTransaction = function (storeName, methode, data) {
        var _this = this;
        return new Promise(function (res, rej) {
            var transaction = _this.db.transaction(storeName, 'readwrite');
            var objectStore = transaction.objectStore(storeName);
            var action = methode;
            transaction.onerror = function (event) {
                rej("Database error during ".concat(action, " on store ").concat(storeName, " : ").concat(event.target.error.message));
            };
            var objectStoreRequest = objectStore[methode](data);
            objectStoreRequest.onsuccess = function (event) {
                res(event.target.result);
            };
            objectStoreRequest.onerror = function (event) {
                rej("Database error during ".concat(action, " on store ").concat(storeName, " : ").concat(event.target.error.message));
            };
        });
    };
    /**
     * @async
     * Add data in store
     * @param {string} storeName Name of the store
     * @param {any} data data
     * @returns {Promise<void>}
     */
    IndexedDBHandler.prototype.create = function (storeName, data) {
        return this.makeTransaction(storeName, type_1.IndexedDBHandlerAction.add, data);
    };
    /**
     * @async
     * Delete data in store
     * @param {string} storeName Name of the store
     * @param {string | number} key key
     * @returns {Promise<void>}
     */
    IndexedDBHandler.prototype.delete = function (storeName, key) {
        return this.makeTransaction(storeName, type_1.IndexedDBHandlerAction.delete, key);
    };
    /**
     * @async
     * Return data search by key in store
     * @param {string} storeName Name of the store
     * @param {string | number} key key
     * @returns {Promise<Object>}
     */
    IndexedDBHandler.prototype.readByKey = function (storeName, key) {
        return this.makeTransaction(storeName, type_1.IndexedDBHandlerAction.get, key);
    };
    /**
     * @async
     * Return all data in store
     * @param {string} storeName Name of the store
     * @returns {Promise<Object[]>}
     */
    IndexedDBHandler.prototype.read = function (storeName) {
        return this.makeTransaction(storeName, type_1.IndexedDBHandlerAction.getAll);
    };
    /**
     * @async
     * Update data in store
     * @param {string} storeName Name of the store
     * @param {any} data data
     * @returns {Promise<void>}
     */
    IndexedDBHandler.prototype.update = function (storeName, data) {
        return this.makeTransaction(storeName, type_1.IndexedDBHandlerAction.put, data);
    };
    return IndexedDBHandler;
}());
exports.IndexedDBHandler = IndexedDBHandler;
//# sourceMappingURL=indexed-db-handler.js.map